import { render } from "./SearchOverlay.vue?vue&type=template&id=a839ee98"
import script from "./SearchOverlay.vue?vue&type=script&lang=js"
export * from "./SearchOverlay.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__